import {
  delayOffset,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  heading: ".list-collections__heading",
  items: ".list-collections--columns__collection",
};

export default node => {
  if (!shouldAnimate(node)) return;
  // Add the animation delay offset variables
  delayOffset(node, [selectors.heading, selectors.items]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
